import React from 'react';
import { makeStyles } from 'tss-react/mui';
import PropTypes from 'prop-types';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Grid from '@mui/material/Grid';

const useStyles = makeStyles()(() => ({
  fullWidth: {
    width: '100%',
  },
}));

export default function ComboBoxField({
  disabled = false,
  handleInputChange = (e) => {},
  idColumn = '',
  label = '',
  labelColumn = '',
  labelColumn2 = '',
  name = '',
  style = '',
  value,
  values,
}) {
  const { classes } = useStyles();

  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      className={classes.fullWidth}
    >
      <Grid className={classes.fullWidth} size={12}>
        <FormControl variant="filled" className={style || classes.fullWidth}>
          <InputLabel id="simple-select-outlined-label">{label}</InputLabel>
          {values.length > 0 && (
            <Select
              labelId="simple-select-outlined-label"
              name={name}
              value={value || ''}
              disabled={disabled}
              onChange={handleInputChange}
            >
              {values.map((v) => (
                <MenuItem key={`${name}${v[idColumn]}`} value={v[idColumn]}>
                  {v[labelColumn]}
                  {labelColumn2 !== '' && v[labelColumn2] && (
                    <span>: {v[labelColumn2]}</span>
                  )}
                </MenuItem>
              ))}
            </Select>
          )}
        </FormControl>
      </Grid>
    </Grid>
  );
}

ComboBoxField.propTypes = {
  disabled: PropTypes.bool,
  handleInputChange: PropTypes.func,
  idColumn: PropTypes.string,
  label: PropTypes.string,
  labelColumn: PropTypes.string,
  labelColumn2: PropTypes.string,
  name: PropTypes.string,
  style: PropTypes.string,
  value: PropTypes.any,
  values: PropTypes.array,
};
